import { arrayFindLastIndex } from "../arrays/arrayFindLastIndex";

const METERS_PER_SECOND_MIN_VALUE_TO_BEAUFORT = [
    // array index is beaufort value, actual values are m/s
    0, 0.3, 1.6, 3.4, 5.5, 8.0, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7,
] as const;

export function metersPerSecondToBeaufort(meterPerSecond: number): number {
    // this formula converts wind speed in m/s to beaufort
    return arrayFindLastIndex(
        METERS_PER_SECOND_MIN_VALUE_TO_BEAUFORT,
        (valueToTest) => meterPerSecond >= valueToTest,
    );
}

export function beaufortToMetersPerSecondMinValue(beaufort: number): number {
    // this formula converts wind speed in beaufort to m/s (minimal value in corresponding range)
    if (beaufort < 0) return 0;

    const minValueIndex = Math.trunc(beaufort);

    return (
        METERS_PER_SECOND_MIN_VALUE_TO_BEAUFORT[minValueIndex] ??
        METERS_PER_SECOND_MIN_VALUE_TO_BEAUFORT[12]
    );
}

export function windDirectionInDegreesFromWindUVValues(
    u: number,
    v: number,
): number {
    // this formula calculates the wind direction in degrees based on u/v wind vectors
    // wind direction is returned based on the following degree values:
    // N = 360°
    // E = 90°
    // S = 180°
    // W = 270°
    //
    // metrological wind direction vs. math wind direction is explained here:
    // http://colaweb.gmu.edu/dev/clim301/lectures/wind/wind-uv

    // formula taken from here: https://stackoverflow.com/a/12632531
    return (270 - (Math.atan2(v, u) * 180) / Math.PI) % 360;
}

export function kilometersPerHourToMetersPerSecond(kmh: number): number {
    return kmh / 3.6;
}
